import {css} from 'lit';
export const styles = css`:host {
  --icon-size: 40px;
  --background: transparent;
  --border: 1px solid transparent;
  --hover-background: var(--gray-200);
  --hover-border: 1px solid var(--gray-400);
  --hover-color: inherit;
  --active-background: var(--gray-300);
  --active-border: 1px solid var(--gray-500);
  --active-color: inherit;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

  :host button {
    border: none;
    padding: 0;
    transition: opacity var(--transition-timing) var(--transition-duration);
    background-color: transparent;
  }

  :host .options {
    display: inline-flex;
  }

  :host > .mobile-share-btn {
    background-color: transparent;
  }

  :host > .mobile-share-btn ef-icon {
    color: var(--dark-text);
  }

  :host ef-dot-menu::part(icon-block facebook) {
      --icon-color-primary: var(--facebook-brand-color);
    }

  :host ef-dot-menu::part(icon-block twitter) {
      --icon-color-primary: var(--twitter-brand-color);
    }

  :host ef-dot-menu::part(icon-block whatsapp) {
      --icon-color-primary: var(--whatsapp-brand-color);
    }

  :host ef-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--icon-size);
    height: var(--icon-size);
    margin: 0 4px;
    color: var(--contrast-light);
    border-radius: 50%;
  }

  :host ef-icon[name='facebook-f:brands'] {
    padding-top: 10px;
    background-color: var(--facebook-brand-color);
    font-size: 30px;
  }

  :host ef-icon[name='x-twitter:brands'] {
    padding-top: 2px;
    background-color: var(--twitter-brand-color);
    font-size: 22px;
  }

  :host ef-icon[name='whatsapp:brands'] {
    background-color: var(--whatsapp-brand-color);
    font-size: 26px;
  }

:host([dropdownmenu='true']) .trigger {
    background: var(--background);
    border: var(--border);
    border-radius: 50%;
    padding: 0;
    transition: opacity var(--transition-timing) var(--transition-duration);
  }

:host([dropdownmenu='true']) .trigger ef-icon {
      font-size: var(--font-size-lg);
      color: var(--dark-text);
      margin: 0;
    }

@media (hover: hover) {
    :host([dropdownmenu='true']) .trigger:hover {
      --background: var(--hover-background);
      --border: var(--hover-border);

      opacity: 1;
    }

      :host([dropdownmenu='true']) .trigger:hover ef-icon {
        color: var(--hover-color);
      }
  }

:host([dropdownmenu='true']) .trigger:active {
    --background: var(--active-background);
    --border: var(--active-border);

    opacity: 0.8;
  }

:host([dropdownmenu='true']) .trigger:active ef-icon {
      color: var(--active-color);
    }

/* TODO

:host {
.trigger {
  position: relative;
  border: 1px solid transparent;
  background-color: transparent;
  color: var(--text-primary);
  z-index: 1;
}

.trigger::before {
  content: '';
  position: absolute;
  left: -8px;
  top: -4px;
  right: -8px;
  bottom: -4px;
  border-radius: 16px;
  background-color: transparent;
  z-index: -1;
}

.trigger[aria-expanded='true'] {
  --text-primary: var(--secondary);
}

.trigger:focus-visible {
  outline-offset: 4px;
}

@media (hover: hover) {
  .trigger:hover {
    --text-primary: var(--secondary);
  }
}

.trigger:active {
  .trigger::before {
    background-color: var(--gray-200);
  }
}
*/
`;
export default styles;
